import { Component, Input } from '@angular/core';

import { OrderLog } from './order-logs.interface';

@Component({
  selector: 'app-order-logs',
  standalone: true,
  imports: [],
  templateUrl: './order-logs.component.html',
  styleUrl: './order-logs.component.scss',
})
export class OrderLogsComponent {
  @Input({ required: true }) title: string;
  @Input({ required: true }) logs: OrderLog[];
}
